import { action, makeObservable } from 'mobx';

import { OrderService } from 'app/service/OrderService';
import { CardOrderCancelReason } from 'app/model/CardOrderCancelReason';
import { LoadStateStore } from 'app/loading/LoadStateStore';
import { MsiAuthenticationService } from 'app/service/MsiAuthenticationService';
import { TokenRequest } from 'app/auth/TokenRequest';

export class RedirectPageStore {
    readonly actionStateStore = new LoadStateStore(true);

    private readonly msiAuthenticationService = new MsiAuthenticationService();

    private readonly orderService = new OrderService();

    constructor() {
        makeObservable(this);
    }

    /**
     * Получение токена авторизации.
     */
    @action
    async getToken(tokenRequest: TokenRequest): Promise<string> {
        return this.actionStateStore.loadData(async () => {
            return this.msiAuthenticationService.getToken(tokenRequest);
        });
    }

    @action
    cancelOrder = async (orderId: string) =>
        this.actionStateStore.loadData(async () => {
            return this.orderService.cancelOrder(
                orderId,
                CardOrderCancelReason.CONSULTATION_REQUIRED,
            );
        });
}
